<template>
    <a-modal
    centered
    title="商品选择"
    :width="1200"
    :bodyStyle="{padding: '16px'}"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="confirm"
    @cancel="cancel"
    >

        <a-spin :spinning="spinning">
            <div class="font-weight font-big mb16 text-color-85">
                仓库选择：
                <a-select v-model="currentWarehouseId" :options="warehouseOptions" @change="warehouseChange" placeholder="请选择" style="width: 200px;"></a-select>
            </div>
            <div class="flex flex-align-start batch-add-goods-modal">
                <div>
                    <div class="pl24 pt16 pb16 border-right-e8 font-weight font-big border-bottom-e8 text-color-85">
                        商品分类
                    </div>
                    <a-menu mode="inline" class="cate-box" :selectedKeys="cateSelectedKeys" @select="cateSelect">
                        <template v-for="item in goodsList">
                            <a-menu-item :key="item.categoryName" class="no-margin border-bottom-e8">
                                <a-tooltip :title="item.categoryName">{{item.categoryName}}</a-tooltip>
                            </a-menu-item>
                        </template>
                    </a-menu>
                </div>
                <div class="pl16 pr16 pb16 pt16 flex-extensible">
                    <div class="mb24">
                        <a-form :form="form" layout="inline" >
                            <a-form-item label="条形码">
                                <a-input placeholder="请输入" v-decorator="['goodsBarCode']" autocomplete="off"></a-input>
                            </a-form-item>
                            <a-form-item label="商品编号">
                                <a-input placeholder="请输入" v-decorator="['goodsNo']" autocomplete="off"></a-input>
                            </a-form-item>
                            <a-form-item label="商品名称">
                                <a-input placeholder="请输入" v-decorator="['goodsName']" autocomplete="off"></a-input>
                            </a-form-item>
                            <a-button type="primary" @click="search">筛选</a-button>
                            <a-button @click="handleReset">重置</a-button>
                        </a-form>
                    </div>
                    <div>
                        <a-table
                        style="word-break:break-all;"
                        bordered
                        size="middle"
                        :pagination="pagination"
                        :columns="columns"
                        :rowSelection="{type: 'checkbox', onChange: tableSelectChange, onSelectAll:onSelectAll, selectedRowKeys: tableSelectedRowKeys}"
                        :dataSource="dataSource"
                        :rowKey="item => JSON.stringify(item)"
                        @change="changePage"
                        >
                        <template slot="goodsBarCode" slot-scope="a">{{(a==' ' || !Boolean(a)) ? "-" : a}}</template>
                        <template slot="goodsNo" slot-scope="a">{{a||"-"}}</template>
                        <template slot="goodsName" slot-scope="a">{{a||"-"}}</template>
                        <template slot="goodsSpecification" slot-scope="a">{{a||"-"}}</template>
                        <template slot="currentInventory" slot-scope="a">{{a||"-"}}</template>
                        </a-table>
                        <div class="mt16 text-fail">您共选择了： {{tableSelectedRowKeys.length}} 个商品</div>
                    </div>
                </div>
            </div>
        </a-spin>
    </a-modal>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    let columns = [
        {
            title: '商品条形码',
            dataIndex: 'goodsBarCode',
                scopedSlots: { customRender: "goodsBarCode" }
        },
        {
            title: '商品编号',
            dataIndex: 'goodsNo',
            scopedSlots: { customRender: "goodsNo" },
            width: 200
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName',
            scopedSlots: { customRender: "goodsName" }
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification',
            scopedSlots: { customRender: "goodsSpecification" }
        },
        {
            title: '库存数量',
            dataIndex: 'currentInventory',
            scopedSlots: { customRender: "currentInventory" }
        },];
    export default {
        name: 'goodsBatchPicker',
        components: {},
        props: {
            selectedRowKeys: {
                type: Array,
                default: () => {return []}
            },
            selectedRow: {
                type: Array,
                default: () => {return []}
            },
        },
        data() {
            return {
                columns,
                dataSource: [],
                flatData: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    total: 0,
                    current: 1,
                    pageSize: 10
                },
                visible: false,
                cateSelectedKeys: [],
                tableSelectedRowKeys: [],
                warehouseOptions: [],
                goodsList: [],
                goodsCate: [],
                currentWarehouseId: undefined,
                loading: false,
                spinning: false
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {
            visible: {
                handler(val) {
                    if (val) {
                        this.getWarehouseList();
                        this.tableSelectedRowKeys = this.selectedRowKeys;
                        this.tableSelectedRow = this.selectedRow;
                    } else {
                        setTimeout(() => {this.dataSource = [];}, 300);
                    }
                }
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this); //筛选表单
        },
        methods: {
            // 重置筛选
            handleReset() {
                this.form.resetFields();
                this.goodsFilter();
            },
            search() {
                this.pagination.current = 1;
                this.goodsFilter();
            },
            warehouseChange() {
                this.getCategoryAndGoods();
            },
            /**
             * @getWarehouseList 获取门店下仓库列表-新
             */
            getWarehouseList() {
                if (!this.shopId) {
                    return false;
                }
                this.$api.ticketDesk.getWarehouseList({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (res) {
                        res.forEach(item => {
                            item.label = item.warehouseName;
                            item.value = item.id;
                        });
                        this.warehouseOptions = res;
                        if (Boolean(res[0])) {
                            this.currentWarehouseId = res[0].id
                            this.getCategoryAndGoods();
                        }
                    }
                });
            },
            /**
             * @getCategoryAndGoods 获取分组及分组下所有商品信息-新
             */
            getCategoryAndGoods() {
                if (!this.shopId) {
                    return false;
                }
                this.spinning = true;
                this.$api.newStorage.sellGoods({
                    body: {
                        shopId: this.shopId,
                        warehouseId: this.currentWarehouseId,
                    }
                }).then(res => {
                    if (Boolean(res) && res.length > 0) {
                        let flatData = [];
                        this.goodsList = res;
                        this.cateSelectedKeys = [res[0].categoryName];

                        let tableSelectedRowKeys = this.$utils.deepClone(this.tableSelectedRowKeys);

                        res.forEach(item => {
                            item.vos.forEach($item => {
                                $item.categoryId = item.categoryName;
                                $item.price = $item.sellPrice;
                                $item.targetId = $item.id || $item.ticketId;
                                $item.warehouseName = this.warehouseOptions.filter(item => {return item.value === this.currentWarehouseId})[0].label;

                                // 选中的商品各仓库分类下分别回填
                                tableSelectedRowKeys = tableSelectedRowKeys.map(key => {
                                    if(key === $item.id) {
                                        key = JSON.stringify($item);
                                    }
                                    return key;
                                })
                            });
                            flatData = flatData.concat(this.$utils.deepClone(item.vos));
                        });
                        this.flatData = flatData;
                        this.tableSelectedRowKeys = tableSelectedRowKeys;
                        this.goodsFilter();
                    }
                    this.spinning = false;
                }).catch(err => {
                    this.spinning = false;
                });
            },
            /**
             * @goodsFilter 商品筛选
             */
            goodsFilter() {
                let flatData = this.flatData;
                let menuSelectedKey = this.cateSelectedKeys[0];
                let { goodsNo, goodsName, goodsBarCode } = this.form.getFieldsValue();
                this.dataSource = flatData.filter(item => {
                    let requirementCate = item.categoryId === menuSelectedKey;
                    let requirementGoodsNo = Boolean(goodsNo) ? new RegExp(goodsNo.replace(/([ .,$ ,^ ,{, [, (, | ,) ,*, +, ?, \\ ])/g, '\\$1')).test(String(item.goodsNo)) : true;
                    let requirementGoodsName = Boolean(goodsName) ? new RegExp(goodsName.replace(/([ .,$ ,^ ,{, [, (, | ,) ,*, +, ?, \\ ])/g, '\\$1')).test(String(item.goodsName)) : true;
                    let requirementGoodsBarCode = Boolean(goodsBarCode) ? new RegExp(goodsBarCode.replace(/([ .,$ ,^ ,{, [, (, | ,) ,*, +, ?, \\ ])/g, '\\$1')).test(String(item.goodsBarCode)) : true;
                    if (requirementCate && requirementGoodsNo && requirementGoodsName && requirementGoodsBarCode) {
                        return true;
                    } else {
                        return false;
                    }
                });
                this.pagination.total = this.dataSource.length;
            },
            //分页回调
            changePage(page) {
                this.pagination = page;
            },
            tableSelectChange(selectedRowKeys, selectedRows) {
                //key即是table的rowKey ,将row转为JSON作为key
                this.tableSelectedRowKeys = selectedRowKeys;
            },
            /**
             * @cateSelect 分类选择
             */
            cateSelect({ item, key, selectedKeys }) {
                this.cateSelectedKeys = selectedKeys;
                this.pagination.current = 1;
                this.goodsFilter();
            },
            /**
             * @confirm 确认
             */
            confirm() {
                this.loading = true;
                let selectedRows = [];
                let selectedRowKeys = [];
                let key = undefined;
                this.tableSelectedRowKeys.forEach(item => {
                    if(item.length > 19) {
                        // 此时key为选择过的JSON字符串
                        key = JSON.parse(item).id;
                        selectedRows.push(JSON.parse(item));
                    }else {
                        // 此时key为未选择过的ID
                        key = item;
                        this.tableSelectedRow.forEach(row => {
                            if(row.id == key) {
                                selectedRows.push(row);
                            }
                        })
                    }
                    selectedRowKeys.push(key);
                })
                this.$emit('confirm', {
                    selectedRowKeys: selectedRowKeys,
                    selectedRows: selectedRows
                });
                this.visible = false;
                this.loading = false;
                this.tableSelectedRowKeys = []
            },
            /**
             * @cancel 取消
             */
            cancel() {
                this.visible = false;
                setTimeout(() => {this.tableSelectedRowKeys = [];}, 300);
            },
            /**
            * @onSelectAll 商品表格全选/取消全选变更事件
             */
            onSelectAll(selected, selectedRows, changeRow) {
                this.tableSelectedRowKeys = this.tableSelectedRowKeys.filter(i => {
                    return !Boolean(this.dataSource.find(item => i === JSON.stringify(item)));
                });
                if (selected) {
                    this.tableSelectedRowKeys = this.tableSelectedRowKeys.concat(this.dataSource.map(i => JSON.stringify(i)));
                };
            },
        }
    };
</script>
<style lang="scss">
    .batch-add-goods-modal {
        border: 1px solid #e8e8e8;
        .border-right-e8 {
            border-right: 1px solid #e8e8e8;
        }
        .border-bottom-e8 {
            border-bottom: 1px solid #e8e8e8;
        }
        .cate-box {
            width: 158px;
            height: 595px;
            overflow-y: scroll;
            &::-webkit-scrollbar {
                display: none;
            }
        }
    }
</style>
